<div class="item">
  @if (currentType === PRODUCT_COMPARATOR_TYPE.FLOATTING) {
    <button type="button" class="btn-remove-product" title="Remove Product" (click)="remove(product)">
      <span class="material-symbols-outlined d-flex"> close </span>
    </button>
  }

  <product-card [product]="product" [lazyPrice]="true" [targetURL]="TARGET_TYPE.BLANK"></product-card>
</div>
